import axios from 'lib/axios'

interface IResponse  {
    map(arg0: (item: any) => Promise<{ name: any; type: any; credits: any; tests_used: any; tests_available: string | number; start_date: string; expiration_date: string; state: string }>): any
    id: number,
    state: boolean,
    testsUsed: number,
    startDate: string,
    expirationDate: string,
    company_id: number,
    subscription_id: number,
    name: string,
    credits: number,
}

type IRes = {
    data: IResponse,
    total_pages: number
    status: 'success' | 'error' | 'OK',
}

// service to create inventory company
export default async function index ( companyId: number, page:number, limit:number) {
    let apiUrl = `${process.env.REACT_APP_MAIN_API}/subscription/${companyId}`

    if (page && limit) {
        apiUrl = `${apiUrl}?page=${page || 1}&limit=${limit || 10}`
    }

    try {
        const response: IRes = await axios.get(apiUrl).then((res) => {
            return res.data
        }).catch((err) => {
            console.error('error on get inventory by company', err)
            // Si es un error 404, devolver un objeto formateado con status=error
            if (err.response && err.response.status === 404) {
                return {
                    status: 'error',
                    message: 'No se encontraron inventarios para esta compañía',
                    data: [],
                    total_pages: 0
                }
            }
            // Para otros errores, devolver un objeto de error genérico
            return {
                status: 'error',
                message: err.message || 'Error al obtener inventarios',
                data: [],
                total_pages: 0
            }
        })
        return response
    }
    catch (error: any) {
        console.error('error on get inventory by company', error)
        // Asegurarse de devolver un objeto de respuesta en lugar de undefined
        return {
            status: 'error',
            message: error.message || 'Error desconocido al obtener inventarios',
            data: [],
            total_pages: 0
        }
    }
}
